import { useState } from 'react';
import {
    Drawer,
    Menu,
    Button,
    Space,
    Divider,
    Typography
} from 'antd';
import {
    MenuOutlined
} from '@ant-design/icons';
import { theme } from '../../../assets/theme';

const { Title, Text } = Typography;

const MobileNavigation = (props) => {
    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <div style={{}}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Button type="primary" style={{ backgroundColor: theme.colors.skyBlue, padding: "15px 7px 15px 15px" }} onClick={showDrawer} icon={<MenuOutlined />}> </Button>

                <Drawer
                    title="Cenvance"
                    placement="left"
                    onClose={onClose}
                    open={open}
                    width={280}
                    styles={{
                        body: {
                            padding: 0,
                        },
                    }}
                >
                    <Menu
                        mode="inline"
                        openKeys={props.openKeys}
                        onClick={props.onClick}
                        triggerSubMenuAction="click"
                        selectedKeys={props.selectedKeys}
                        items={props.menuItems}
                        style={{ border: 'none' }}
                    />
                    <Divider style={{ margin: '16px 0' }} />
                </Drawer>
            </Space>
        </div>
    );
};

export default MobileNavigation;